import { useEffect, useRef } from 'react';

import {
  completeOfflineSyncForConsumer,
  getOfflineSyncPending,
  registerOfflineSyncConsumer,
  unregisterOfflineSyncConsumer,
} from '../../components/_core/OfflineHandler/offline-handler.container';

// A completed offline sync flags every registered consumer in a shared pending ledger; this
// hook clears its own entry (keyed by its ref) after refetching, so every consumer reacts.
export const useRefetchAfterOfflineSync = (
  refetch: () => void | Promise<unknown>,
  called: boolean,
  loading: boolean,
  // Defers the refetch while the consumer's query is skipped/paused — Apollo's `refetch`
  // ignores `skip`, so firing it on a paused query sends a real network request.
  active = true,
) => {
  const keyRef = useRef<object>();
  if (!keyRef.current) keyRef.current = {};
  const key = keyRef.current;

  useEffect(() => {
    registerOfflineSyncConsumer(key);
    return () => unregisterOfflineSyncConsumer(key);
  }, [key]);

  const pending = !!getOfflineSyncPending().get(key);
  useEffect(() => {
    if (pending && called && !loading && active) {
      completeOfflineSyncForConsumer(key);
      Promise.resolve(refetch()).catch((err) => {
        console.error('useRefetchAfterOfflineSync refetch failed:', err);
      });
    }
  }, [pending, called, loading, active, refetch, key]);
};
